import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const CommentSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Comment Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Message",
                                key: 'message'
                            },
                            {
                                label: "Status",
                                key: 'status',
                                format: "titleCase"
                            },
                            
                        ]}
                        columnB={[
                            {
                                label: "Owner",
                                key: 'owner',
                                format: 'ModelLink',
                            },
                            {
                                label: "Story",
                                key: "parent",
                                format: 'ModelLink'
                            },
                        ]}
                        columnC={[
                            {
                                label: "Created On",
                                key: "created",
                                format: "onAndBy",
                            }
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default CommentSingleView;
